import { createFileRoute } from '@tanstack/react-router'
import { ApiKeyManagement } from '../../../features/admin/ApiKeyManagement'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/api-keys')({
  component: AdminApiKeysRoute,
})

/* ───── Route Component ───── */

function AdminApiKeysRoute() {
  return <ApiKeyManagement />
}
